
function wrapItems(element, first, last) {
    var item = element.find('.selling-points__items-wrap').children('.selling-points__item');
    item.find('.w-eq-height').css('height', 'auto');
    item.each(function () {
        var itemEq = element.find('.selling-points__items-wrap').children('.selling-points__item').slice(first, last);
        itemEq.addClass('equalized');
        $('.selling-points__items-wrap > .equalized').wrapAll('<div></div>');
    });
}

function sortingItems(res) {
    var res = res;
    var itemsWrap = $('.selling-points');
    var sliceNumb;
    itemsWrap.each(function () {
        if ($(this).hasClass('selling-points--3')) {
            sliceNumb = 3;
            wrapItems($(this), 0, sliceNumb);
        }
        else if ($(this).hasClass('selling-points--4')) {
            if (res >= 128) {
                sliceNumb = 4;
            }
            else {
                sliceNumb = 2
            }
            wrapItems($(this), 0, sliceNumb);
        }
        else {
            if (res >= 128) {
                sliceNumb = 5;
            }
            else if (res == 96) {
                sliceNumb = 3
            }
            else if (res == 64) {
                slicwNumb = 2
            }
            wrapItems($(this), 0, sliceNumb);
        }
    });
}

function setEqHeightInRow() {
    $('.selling-points__items-wrap > *:not(.selling-points__item)').each(function () {
        var itemEq = $(this).find('.w-eq-height');
        var maxH = itemEq.eq(0).height();
        itemEq.each(function () {
            maxH = ($(this).height() > maxH) ? $(this).height() : maxH;
        });
        itemEq.height(maxH);
    });
    $('.selling-points__item').removeClass('equalized').unwrap();
}

$(window).on('load', function () {
    var res = resolutionCheck();
    if ($('.selling-points').length && res > 32) {
        sortingItems(res);
        setEqHeightInRow();
    }
});
$(window).on('resize orientationchange', function () {
    var res = resolutionCheck();
    if ($('.selling-points').length && res > 32) {
        sortingItems(res);
        setEqHeightInRow();
    }
});	
